import { render, staticRenderFns } from "./ligne.vue?vue&type=template&id=bb58ba28"
import script from "./ligne.vue?vue&type=script&lang=js"
export * from "./ligne.vue?vue&type=script&lang=js"
import style0 from "./ligne.vue?vue&type=style&index=0&id=bb58ba28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports